/**
 * Banners are commercials that fill empty spaces across the app.
 * Click on every banner triggers an action. Action can be:
 * 1) open link in new tab
 * 2) open new popup window
 * 3) open in app link
 */
var BannerVariant = {
    Primary: 'primary',
    PrimaryAlt: 'primary-alt',
    Secondary: 'secondary',
    SecondaryAlt: 'secondary-alt',
    SecondaryAlt2: 'secondary-alt-2',
    Tertiary: 'tertiary',
    TertiaryAlt: 'tertiary-alt',
    NapoleonPrimary: 'napoleon-primary',
    NapoleonSecondary: 'napoleon-secondary',
};

export { BannerVariant };
